export default __webpack_public_path__ + "static/media/botas-seguridad-mujer.c7be9a35.png";